// extracted by mini-css-extract-plugin
export default {"container":"WN","productarea":"XN","btn":"YN","promowrapper":"ZN","upsellarea":"aO","subtitle":"bO","system":"cO","desc":"eO","cardswrap":"fO","cards":"gO","squareloadingcontainer":"hO","squareloading33":"iO"};
    if(module.hot) {
      // 1714422956861
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  